import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import * as zIndex from '@tencent/exeditor3-ui-kit/dist/resizer/zIndex.js';
const NO_OUTLINE = 'no-outline';
const containerClassName = 'exeditor-picture';
export class InlinePictureEditView {
    constructor(editor, node, getPos, options) {
        this.editor = editor;
        this.node = node;
        this.getPos = getPos;
        this.options = options;
        // 状态
        this.imageState = {};
        this.handleReadOnlyChange = (readonly) => {
            this.image.editable = !readonly;
        };
        const info = node.attrs.info || {};
        this.editor.emit('ex:picture:construct', {
            info,
            pos: getPos(),
            node,
        });
        this.image = this.createImage(info);
        const container = document.createElement('span');
        container.classList.add(containerClassName, NO_OUTLINE);
        container.appendChild(this.image);
        if (info.float) {
            container.style.display = 'block';
            container.style.float = info.float;
        }
        this.dom = container;
        this.editor.on('readonly', this.handleReadOnlyChange);
        this.updateImageProperties(info);
    }
    update(node) {
        this.node = node;
        const { info = {}, uploading } = node.attrs;
        // 重新上传
        if (info.src !== this.image.src || uploading) {
            // 更换 src 导致重新创建 EditView
            return false;
        }
        this.editor.emit('ex:picture:change', {
            info,
            pos: this.getPos(),
            node,
        });
        this.handleUpdate();
        return true;
    }
    selectNode() {
        this.image.active = true;
        this.dom.style.setProperty('z-index', zIndex.box.toString());
    }
    deselectNode() {
        this.image.active = false;
        this.dom.style.removeProperty('z-index');
    }
    destroy() {
        this.editor.emit('ex:picture:destroy', {
            info: this.node.attrs.info,
            pos: this.getPos(),
            node: this.node,
        });
        this.editor.off('readonly', this.handleReadOnlyChange);
    }
    createImage(info) {
        const image = document.createElement('exeditor-picture-block-container');
        image.src = info.src;
        image.editable = this.options.editable;
        image.allowFloat = this.options.allowFloat;
        image.addEventListener('remove', () => {
            const pos = this.getPos();
            this.editor.delete(pos, pos + 1);
        });
        image.addEventListener('restore', () => {
            const { width, height, rotate, crop, float } = image;
            Object.assign(this.imageState, { width, height, rotate, crop, float });
            this.changeAttributes();
        });
        image.addEventListener('change', () => {
            const { width, height, rotate, crop, float } = image;
            Object.assign(this.imageState, { width, height, rotate, crop, float });
            this.changeAttributes();
        });
        return image;
    }
    handleUpdate() {
        const { node } = this;
        const info = node.attrs.info;
        const imageState = { ...info };
        // 同步变更到视图
        ['width', 'height'].forEach((key) => {
            imageState[key] = imageState[key] || 0;
        });
        this.imageState = imageState;
        this.updateContainerProperties(this.imageState);
        this.updateImageProperties(this.imageState);
    }
    updateContainerProperties({ float }) {
        if (float) {
            this.dom.style.display = 'block';
            this.dom.style.float = float;
        }
        else {
            this.dom.style.removeProperty('display');
            this.dom.style.removeProperty('float');
        }
    }
    updateImageProperties({ width, height, rotate, crop, float, }) {
        if (width) {
            this.image.width = width;
        }
        if (height) {
            this.image.height = height;
        }
        this.image.rotate = rotate || 0;
        this.image.crop = crop || null;
        this.image.float = float || '';
    }
    changeAttributes() {
        const { node, image } = this;
        const { width, height, rotate, crop, float } = image;
        const oldInfo = node.attrs.info;
        const info = {
            ...oldInfo,
            width,
            height,
            rotate,
            crop,
            float,
        };
        const pos = this.getPos();
        this.editor.patchNodeAttr(pos, { info });
    }
}
//# sourceMappingURL=inline-picture-edit-view.js.map